import { selectPolicy } from './selectPolicy';

export function getPolicyAddress(riskUnit, lossDate) {
  let thePolicy = JSON.parse(window.sessionStorage.getItem('thePolicy'));
  if (!thePolicy) {
    thePolicy = selectPolicy(riskUnit, lossDate);
    if (thePolicy) {
      window.sessionStorage.setItem('thePolicy', JSON.stringify(thePolicy));
      window.dispatchEvent(new StorageEvent('storage', { key: 'thePolicy' }));
    }
  }
  const policyLocation = thePolicy?.policyLocation?.[0];
  const address = policyLocation ? `${policyLocation.addressLine1} ${policyLocation.city} ${policyLocation.provinceCode} ${policyLocation.postalCode}` : null;
  return address;
}
